import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from './pages/Login/login';
import Home from "./pages/Home/home";
import './bootstrap.min.css'


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
